import _ from 'lodash';

// Imports each Angular components/directive HTML template from src/app and adds
// adds it to Angular's $templateCache at the URL expected by the legacy Angular
// source.
const populateTemplateCache = [
  '$templateCache',
  function ($templateCache) {
    populateTemplateCacheForPath(require.context('../../src/app/', true, /.*\.html$/), 'app/');
    populateTemplateCacheForPath(
      require.context('../../src/templates/', true, /.*\.html$/),
      'templates/'
    );
    populateTemplateCacheForPath(require.context('../../src/views/', true, /.*\.html$/), 'views/');

    function populateTemplateCacheForPath(context, prefix) {
      _.forEach(context.keys(), (key) => {
        const templateUrl = _.replace(key, /^.\//, prefix);
        const html = context(key);
        $templateCache.put(templateUrl, html);
      });
    }
  },
];

export {populateTemplateCache};
